export const REQUEST_CONSENT_LOADING_STATES = {
    CONSENT_REQUEST_COUNT_LOADING: "CONSENT_REQUEST_COUNT_LOADING",
    CONSENT_REQUEST_COUNT_READY: "CONSENT_REQUEST_COUNT_READY",
    CONSENT_MATCH_FEE_LOADING: "CONSENT_MATCH_FEE_LOADING",
    CONSENT_MATCH_FEE_READY: "CONSENT_MATCH_FEE_READY",
    CONSENT_PAYEE_LOADING: "CONSENT_PAYEE_LOADING",
    CONSENT_PAYEE_READY: "CONSENT_PAYEE_READY",
}